import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

export function AdminToolbar({ title, count, subtitle, children }) {
  return (
    <Box className="admin-toolbar">
      <Box className="admin-toolbar-heading">
        <HStack spacing={0} gap={2} flexWrap="wrap">
          <Text as="h1" className="admin-section-title">{title}</Text>
          {count}
        </HStack>
        {subtitle && <Text fontSize="sm" color="gray.600">{subtitle}</Text>}
      </Box>
      <Box className="admin-toolbar-actions">{children}</Box>
    </Box>
  );
}

export function AdminFilters({ children, ...props }) {
  return <Box className="admin-filters" {...props}>{children}</Box>;
}

export function AdminActions({ children, ...props }) {
  return <Box className="admin-actions" {...props}>{children}</Box>;
}
